<template>
  <YandexMaps
      v-if="screen === 'selectZone'"
      :myPosition="myPosition"
      :polygons="parameters.zones"
      @zone-selected="zoneSelected"
  />
  <YandexMaps
      v-if="screen === 'selectQuestionInZone'"
      :myPosition="myPosition"
      :polygons="[parameters.currentZone]"
      :points="parameters.questions"
      @point-selected="pointSelected"
  />
</template>

<script>
import YandexMaps from './YandexMaps.vue'
import {getImageUriOrDefault} from '../../../common-functions'

const timeToWaitForGeoSeconds = 5;

export default {
  props: [
      'parameters',
      'screen'
  ],
  emits: ['inOkRadius', 'skipQuestion', 'zoneSelected', 'pointSelected'],
  data() {
    return {
      myPosition: null,
      accuracy: 0,
      waitedSomeTime: false,
      debug: false,
      debugMessage: 'debug'
    };
  },

  geolocationWatch: null,

  methods: {
    updateMyPosition(currentPosition) {
      this.myPosition = [
        currentPosition.coords.latitude,
        currentPosition.coords.longitude
      ];

      this.accuracy = currentPosition.coords.accuracy;
      console.log('updated my position',currentPosition.coords);
    },

    zoneSelected(zoneId) {
      console.log('ZONE')
      this.$emit('zoneSelected', zoneId);
    },

    pointSelected(pointId) {
      console.log('pointSelected(pointId)', pointId);
      this.$emit('pointSelected', pointId);
    }
  },

  computed: {
    cssImageUrl() {
      return 'url("' + getImageUriOrDefault(this.verticalPlaceImageUrl) + '")';
    }
  },

  components: {
    YandexMaps,
    // VueMarkdown
  },

  mounted() {
    const component = this;

    if (location.search.indexOf('debug_navigation') >= 0) {
      this.debug = true;
    }

    const geolocationOptions = {
      maximumAge: 1000,
      enableHighAccuracy: true
    };

    this.debugMessage = 'setting watch listener';

    component.$options.geolocationWatch = navigator.geolocation.watchPosition(
        (currentPosition, e) => {
          if (e) {
            console.log('err watchPosition')
            console.error(e);
            this.debugMessage = 'error: ' + e.message + '<br>' + e.stack;
            return;
          }

          const cloneAsObject = (obj) => {
            if (obj === null || !(obj instanceof Object)) {
              return obj;
            }
            var temp = (obj instanceof Array) ? [] : {};
            for (var key in obj) {
              temp[key] = cloneAsObject(obj[key]);
            }
            return temp;
          };

          // todo: https://stackoverflow.com/a/65242535

          this.debugMessage = 'currentPosition: ' + JSON.stringify(cloneAsObject(currentPosition));
          component.updateMyPosition(currentPosition);

          component.accuracy = currentPosition.coords.accuracy;
          console.log(currentPosition.coords);
        },
        (positionError) => {
          console.error(positionError);
        },
        geolocationOptions
    );

    window.navigationWaitForGeoTimeout = setTimeout(() => {
      window.navigationWaitForGeoTimeout = null;
      component.waitedSomeTime = true;
    }, timeToWaitForGeoSeconds * 1000);
  },

  beforeUnmount() {
    this.$options &&
      this.$options.geolocationWatch &&
    navigator.geolocation.clearWatch(this.$options.geolocationWatch);

    this.debugMessage = 'cleared watch';

    this.$options && (this.$options.geolocationWatch = null);

    if (window.navigationWaitForGeoTimeout) {
      clearTimeout(window.navigationWaitForGeoTimeout);
      window.navigationWaitForGeoTimeout = null;
    }
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
html, body {
  height: 100%;
  margin: 0;
}
</style>

<style scoped>

.navigation-background {
  width: 100%;
  height: 100%;
  flex: 1;
  background-image: v-bind('cssImageUrl');
  background-repeat: no-repeat;
  background-size: cover;
}

.navigation {
  width: 100%;
  height: 100%;
  flex: 1;
  background: #ffffffad;
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
  position: relative;
}

.navigation .point-header {
  min-height: 60px;
  width: 100%;
  text-align: center;
  font-size: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navigation .content-text {
  margin: 10px;
  background-color: #ffffffdf;
  font-family: Arial, Serif;
  text-indent: 1em;
  font-size: 20px;
  overflow-y: auto;
  max-height: 30%;
}

.navigation .content-text >>> p {
  margin-block-start: 0;
  margin-block-end: 0;
}

.navigation .instructions {
  color: red;
  text-align: center;
  padding: 10px;
}

.navigation .distance {
  width: 100%;
  font-family: motelking, Arial, sans-serif;
  text-align: center;
  font-size: 25px;
  padding: 7px 0 7px 0;
}

.navigator-frame {
  width: 100%;
  height: 100%;
  flex: 1;
}

.close:before {
  content: " ";
  position: absolute;
}

.debug {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  opacity: 0.9;
  word-break: break-all;
  background-color: yellow;
}

@media (max-width: 375px) {
  .navigation .distance {
    font-size: 18px;
  }
  .navigation .instructions {
    padding: 6px;
  }
  .navigation .point-header {
    min-height: 45px;
  }
  .navigation .content-text {
    margin: 0 10px 10px 10px;
    font-size: 18px;
  }
}


.content-text::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 20px #2c2c2cc9;
  border-radius: 10px;
  background-color: white;
}
.content-text::-webkit-scrollbar {
  width: 8px;
  height: 0;
}
.content-text::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(0 0 0);
}
.content-text {
  box-shadow: none;
  background: /* Shadow covers */ linear-gradient(white 30%, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%, /* Shadows */ radial-gradient(50% 0, farthest-side, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)), radial-gradient(50% 100%, farthest-side, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)) 0 100%;
  background: /* Shadow covers */ linear-gradient(white 30%, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%, /* Shadows */ radial-gradient(farthest-side at 50% 0, rgb(0 0 0 / 50%), rgba(0, 0, 0, 0)), radial-gradient(farthest-side at 50% 100%, rgb(0 0 0 / 50%), rgba(0, 0, 0, 0)) 0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
}
</style>
